<template>
  <div class="usercontainer hc-container">
    <div class="usercontainer-menu">
      <ul>
        <li :class="{ active: currentRoute == 'userIndex' }" @click="HcGo('/user')">个人信息</li>
        <li :class="{ active: currentRoute == 'userAddress' }" @click="HcGo('/user/address')">我的地址</li>
        <li :class="{ active: currentRoute == 'userPwd'}" @click="HcGo('/user/pwd')">修改密码</li>
        <li :class="{ active: currentRoute == 'userNotic'}" @click="HcGo('/user/notic')">我的消息</li>
        <li :class="{ active: currentRoute == 'userOrders'}" @click="HcGo('/user/orders')">我的订单</li>
     
      </ul>
    </div>
    <div class="usercontainer-content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        currentRoute:"",
    };
  },
  created() {
    // 获取当前路由名称
    this.currentRoute = this.$route.name;
  
   
  },
  watch: {
    $route(to, from) {
      // 获取当前路由名称
      this.currentRoute = to.name;
       console.log(this.currentRoute);
    },
  },
  methods: {},
};
</script>
<style scoped lang="less">
.usercontainer {
  width: 100%;
  padding: 40px 0px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  &-menu {
    ul {
      li {
        line-height: 60px;
        margin: 10px 0px;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
        &.active,
        &:hover {
          color: #f0b916;
        }
      }
    }
  }
  &-content {
    width: 1070px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pc/user.vue